module.exports = __webpack_public_path__ + "assets/img/Type E (49).4eb4fd9f.jpg";